export default __webpack_public_path__ + "Content/Images/content/Remote-Deposit-Business.jpg";